import * as React from "react";
export class GeneralScoreboard extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-general-scoreboard" + (this.props.modifier ? ` rj-general-scoreboard--${this.props.modifier}` : "") },
            React.createElement("div", { className: "rj-general-scoreboard__players" },
                this.props.scoreFirstPlayer.map((item, index) => (React.createElement("div", { key: index, className: "rj-general-scoreboard__info" }, item))),
                React.createElement("div", { className: "rj-general-scoreboard__total-info" }, this.props.totalFirstPlayer)),
            React.createElement("div", { className: "rj-general-scoreboard__players" },
                this.props.scoreSecondPlayer.map((item, index) => (React.createElement("div", { key: index, className: "rj-general-scoreboard__info" }, item))),
                React.createElement("div", { className: "rj-general-scoreboard__total-info" }, this.props.totalSecondPlayer))));
    }
}
//# sourceMappingURL=GeneralScoreboard.js.map